/* Empty / no-results / skeleton placeholders for the MobileCases page.
   Extracted to keep MobileCases.jsx under the 300-line rule. */
import { Link } from "react-router-dom";
import { MagnifyingGlass, Scales } from "@phosphor-icons/react";

export function EmptyState() {
  return (
    <section
      className="bg-white/60 backdrop-blur-md rounded-[24px] border border-white/60 shadow-[0_2px_18px_rgba(10,25,47,0.08)] p-8 text-center"
      data-testid="mobile-cases-empty"
    >
      <MagnifyingGlass size={48} weight="duotone" color="#D4AF37" className="mx-auto mb-3" />
      <h3 className="font-tajawal text-[20px] font-bold text-[#0A192F]">لا توجد قضايا بعد</h3>
      <p className="text-[14px] text-[#5A6470] mt-2 leading-relaxed">ابدأ بتحليل قضيتك الأولى الآن.</p>
      <Link
        to="/analyze"
        data-testid="mobile-empty-cta"
        className="inline-flex items-center gap-2 mt-5 bg-gradient-to-br from-[#E6C463] to-[#B8860B] text-white rounded-full px-5 py-2.5 text-[14px] active:scale-95 transition-transform shadow-md"
      >
        <Scales size={16} weight="fill" /><span>تحليل قضية</span>
      </Link>
    </section>
  );
}

export function NoResults({ query, onClear }) {
  return (
    <section className="text-center py-10" data-testid="mobile-cases-no-results">
      <MagnifyingGlass size={40} weight="duotone" color="#8A8A8A" className="mx-auto mb-2" />
      <h3 className="font-tajawal text-[17px] font-bold text-[#0A192F]">لا توجد نتائج</h3>
      <p className="text-[13px] text-[#5A6470] mt-1">لا تطابق أي قضية الكلمة «{query}»</p>
      <button
        type="button" onClick={onClear}
        className="mt-3 text-[13px] text-[#B8860B] underline underline-offset-2"
      >
        مسح البحث
      </button>
    </section>
  );
}

export function Skeleton() {
  return (
    <div className="space-y-3" data-testid="mobile-cases-loading">
      {[1, 2, 3].map((i) => (
        <div key={i} className="h-28 rounded-[20px] bg-white/60 animate-pulse" />
      ))}
    </div>
  );
}
